// CacheKey 7cb5c2b1a2a46e3a467ad9d5ed565629
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  es: {
    date: {
      abbr_day_names: [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      abbr_month_names: [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      day_names: [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      formats: {
        default: "%d/%m/%Y",
        long: "%d de %B de %Y",
        short: "%d de %b"
      },
      month_names: [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      order: [
        "day",
        "month",
        "year"
      ]
    },
    time: {
      am: "am",
      formats: {
        default: "%A, %d de %B de %Y %H:%M:%S %z",
        long: "%d de %B de %Y %H:%M",
        short: "%d de %b %H:%M"
      },
      pm: "pm"
    },
    time_zones: {
      est: "hora del este",
      edt: "hora del este",
      cst: "hora del centro",
      cdt: "hora del centro",
      mst: "hora de la montaña",
      mdt: "hora de la montaña",
      pst: "hora del Pacífico",
      pdt: "hora del Pacífico",
      hst: "hora de Hawái-Aleutiano",
      hdt: "hora de Hawái-Aleutiano",
      akst: "hora de Alaska",
      akdt: "hora de Alaska"
    }
  }
}

